import type {
  LlmBidSearchSuggestion,
  LlmBidSearchSuggestions,
} from './llm-bid-search-suggestions.model';

export interface GenerateLlmBidSearchSuggestionsOptions {
  readonly projectId?: number;
  readonly suggestions?: readonly LlmBidSearchSuggestion[];
}

export function generateLlmBidSearchSuggestionsObject({
  projectId = 1,
  suggestions = [
    { text: 'React developer with mobile experience' },
    { text: 'freelancer with 5-star reviews' },
    { text: 'experienced full stack developer' },
    { text: 'has past work in web apps' },
    { text: 'available now' },
    { text: 'verified freelancer' },
    { text: 'degree in computer science' },
  ],
}: GenerateLlmBidSearchSuggestionsOptions = {}): LlmBidSearchSuggestions {
  return {
    id: projectId,
    suggestions,
  };
}
